export default "__VITE_ASSET__aT6BoVdu__"